export default () => ({
    show: false,
    loading: false,
    checkout: false,
    toggle () {
        this.show = !this.show;
        Grebify.noScroll(this.show);
    }
});